import React from 'react';

import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import Nav from 'react-bootstrap/Nav';
import { Avatar, Space } from 'components/barbr';
import { useHistory, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';

import { MY_BOOKINGS_ROUTE, LOGIN_ROUTE, SIGNUP_ROUTE } from 'appRoutes/routeConstants';
import { getProfileRoute } from 'appRoutes/routeHelpers';
import { isEmpty } from '_dash';
import { BARBER_LP_URL, AUTHORIZATION_KEY } from 'global_constants';

import logo from 'assets/white-logo.svg';
import AccountHook from 'hooks/account';
import placeholder from 'assets/user-placeholder.png';
import { useHelpCrunch } from 'context/helpCrunchContext';

import './style.scss';

const navItems = [
  {
    label: 'My bookings',
    path: MY_BOOKINGS_ROUTE,
  },
];

const AppWebHeader = React.memo(({ accountData, setAccountData, redirectOnLogout = true }) => {
  const { isHelpCrunchReady } = useHelpCrunch();
  const params = useParams();
  const history = useHistory();
  const isLoggedIn = !isEmpty(accountData);

  const { username } = params;

  const onLogout = () => {
    setAccountData({});
    localStorage.removeItem(AUTHORIZATION_KEY);
    localStorage.clear();
    if (redirectOnLogout) {
      history.push(LOGIN_ROUTE);
    }
  };

  const onSignUp = () =>
    history.push({
      pathname: SIGNUP_ROUTE,
      ...(username
        ? {
            state: { username: username },
            search: `?next=${getProfileRoute(username)}`,
          }
        : {}),
    });

  const onLogin = () =>
    history.push({
      pathname: LOGIN_ROUTE,
      ...(username
        ? {
            state: { username: username },
            search: `?next=${getProfileRoute(username)}`,
          }
        : {}),
    });

  const onHelp = () => {
    if (isHelpCrunchReady) {
      window?.HelpCrunch('openChat');
    }
  };

  const onBarbers = () => window.open(BARBER_LP_URL, '_blank');

  return (
    <div className='app-web-header'>
      <Space justify='space-between' align='center'>
        <img src={logo} alt='Barbr' width={96} height={24} />
        <Space align='center' size={28}>
          <Choose>
            <When condition={isLoggedIn}>
              <Dropdown className='user-dropdown'>
                <Dropdown.Toggle as='div'>
                  <Avatar size={28} shape='circle' src={placeholder} />
                  <span>
                    {accountData?.first_name} {accountData?.last_name?.charAt(0)}.
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {navItems.map((item, idx) => (
                    <LinkContainer
                      key={idx}
                      to={{
                        pathname: item.path,
                        ...(username
                          ? {
                              search: `?next=${getProfileRoute(username)}`,
                            }
                          : {}),
                      }}>
                      <Dropdown.Item>{item.label}</Dropdown.Item>
                    </LinkContainer>
                  ))}
                  <Dropdown.Item onClick={onHelp}>Get Help</Dropdown.Item>
                  <Dropdown.Item onClick={onLogout}>Logout</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </When>
            <Otherwise>
              <Nav.Item onClick={onSignUp} className='navItem'>
                Sign Up
              </Nav.Item>
              <Nav.Item onClick={onLogin} className='navItem'>
                Log In
              </Nav.Item>
            </Otherwise>
          </Choose>
          <Nav.Item onClick={onHelp} className='navItem'>
            Help
          </Nav.Item>
          <Button size='lg' variant='light' className='text-uppercase barber-button' onClick={onBarbers}>
            SET UP MY BUSINESS 💈
          </Button>
        </Space>
      </Space>
    </div>
  );
});

export default AccountHook(AppWebHeader);
